var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8218 9.93793L7.06511 6.1814C6.82075 5.93693 6.42567 5.93693 6.18131 6.1814C5.93696 6.42575 5.93696 6.82084 6.18131 7.0652L9.93796 10.8218L6.18131 14.5784C5.93696 14.8228 5.93696 15.2178 6.18131 15.4622C6.42567 15.7066 6.82075 15.7066 7.06511 15.4622L10.8218 11.7056L14.5784 15.4622C14.8228 15.7066 15.2178 15.7066 15.4622 15.4622C15.5841 15.3404 15.6453 15.1803 15.6453 15.0203C15.6453 14.8603 15.5841 14.7003 15.4622 14.5784L11.7056 10.8218L15.4622 7.06519C15.5841 6.9433 15.6453 6.7833 15.6453 6.6233C15.6453 6.46329 15.5841 6.30329 15.4622 6.1814C15.2178 5.93693 14.8228 5.93693 14.5784 6.1814L10.8218 9.93793Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/remove.1da1bb4a50bda34a6d7c8f38cbf8fb08.svg";
export { ForwardRef as ReactComponent };